// SIZING
export const MD_BREAKPOINT = "850px";
export const SM_BREAKPOINT = "520px";
